import { useAuth } from '../../context/AuthContext';

/**
 * Route-level role gate. Renders children only if the user holds the required
 * role on the specified facility. Site admins (isAdmin) bypass the gate.
 *
 * Usage:
 *   <RoleGuard requireFacilityAdmin facilityId={facilityId}>
 *     <FacilityDashboard />
 *   </RoleGuard>
 */
export default function RoleGuard({ requireFacilityAdmin, facilityId, children }) {
    const { isAdmin, isFacilityAdmin, facilityId: userFacilityId } = useAuth();

    if (requireFacilityAdmin) {
        const ok = isAdmin || (isFacilityAdmin && userFacilityId === facilityId);
        if (!ok) {
            return <div className="role-guard-denied">You are not authorized to view this page.</div>;
        }
    }

    return children;
}
